module.exports = __webpack_public_path__ + "img/img_2.7e60b4e8.png";